import { yayApi } from '../baseApi'
import { LOAD_NUMBER } from 'config'
import { Post } from 'lib/_types'
import { pathApiConversations, pathApiConversationsRootPosts } from 'lib/paths'

export const conversationApi = yayApi
  .enhanceEndpoints({
    addTagTypes: ['Conversation/Base'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getConversation: build.query<
        {
          posts: Array<Post>
          result: 'success'
        },
        {
          conversationId: string
          group_id: string
          thread_id: string
          reverse?: boolean
          from_post_id?: string
        }
      >({
        providesTags: (_0, _1, args) => {
          return [{ type: 'Conversation/Base', id: args?.from_post_id }]
        },
        query: ({
          conversationId,
          group_id,
          thread_id,
          reverse,
          from_post_id,
        }) => ({
          url: pathApiConversations({ conversationId }),
          params: {
            number: LOAD_NUMBER,
            ...(group_id && { group_id }),
            ...(thread_id && { thread_id }),
            ...(reverse && { reverse }),
            ...(from_post_id?.length > 0 &&
              from_post_id != '0' && { from_post_id }),
          },
        }),
        keepUnusedDataFor: 0,
      }),

      getConversationRootPosts: build.query<
        {
          posts: Array<Post>
          result: 'success'
        },
        {
          conversationIds: Array<number>
        }
      >({
        providesTags: (_0, _1, args) => {
          return [
            {
              type: 'Conversation/Base',
              id: args?.conversationIds?.join?.(','),
            },
          ]
        },
        query: ({ conversationIds }) => ({
          url: pathApiConversationsRootPosts,
          params: {
            ids: conversationIds,
          },
          paramsSerializer: (params) => {
            return params?.ids?.map?.((x: number) => `ids[]=${x}`)?.join?.('&')
          },
        }),
        // This should be harmless. Given each request should be unique enough to some degree.
        // keepUnusedDataFor: 0,
        transformResponse: (response) => {
          return {
            ...response,
            posts: response?.posts?.map?.((x) => {
              return {
                ...x,
                _isRootPost: true,
              }
            }),
          }
        },
      }),
    }),
    overrideExisting: false,
  })

export const {
  endpoints,
  useGetConversationQuery,
  useGetConversationRootPostsQuery,
} = conversationApi
